function syncActiveLine(){
	var array = [];
	$(".section .anchor").each(function(){
		if(scrollTop >= Math.floor($(this).offset().top)){
			array.push($(this).attr('id'));
		}
	})
	$("[data-to-section='" + array[array.length - 1] + "']").parent().addClass('active').siblings().removeClass('active');
	var activeElem = $(".cw-submenu li.active");
	var offsetLeft = $(".cw-submenu .overflow-container").offset().left;
	var scrollOffset = $(".cw-submenu .overflow-container").scrollLeft();
	$(".cw-submenu .track")
	.css('left', activeElem.offset().left - offsetLeft + scrollOffset)
	.width(activeElem.outerWidth());
}
syncActiveLine();
$(window).on('resize', syncActiveLine);
$(window).on('scroll', syncActiveLine);

$("[data-to-section]").click(function(e){
    var elem = $(this).data("to-section");
    if($("#" + elem).length) $.scrollTo($("#" + elem), {
    	duration: 1500,
    	onAfter: syncActiveLine()
    });
})

var scrollElem = $(".cw-submenu .overflow-container");
scrollElem.on('scroll', function(){
	if((scrollElem.scrollLeft() + scrollElem.width() + 4) >= Math.floor($("ul", scrollElem).width())){
		$("[data-scroll-right]").fadeOut();
	}else{
		$("[data-scroll-right]").fadeIn();
	}
	if(scrollElem.scrollLeft() == 0){
		$("[data-scroll-left]").fadeOut();
	}else{
		$("[data-scroll-left]").fadeIn();
	}
}).trigger("scroll");

$("[data-scroll-left]").click(function(e){
	e.preventDefault();
	scrollElem.scrollTo("-=250px", {axis:"x"});
})
$("[data-scroll-right]").click(function(e){
	e.preventDefault();
	scrollElem.scrollTo("+=250px", {axis:"x"});
})

$(window).resize(function(){
	$("main").css('padding-top', $(".inner-banner").outerHeight());
	if(scrollElem.outerWidth() >= scrollElem.children("ul")){
		$("[data-scroll-left], [data-scroll-right]").fadeOut()
	}else{
		scrollElem.trigger("scroll");
	}
}).trigger('resize');

var tl = gsap.timeline();
tl.from(".inner-banner .section-title", {
  duration:1,
  delay:1.5,
  opacity:0,
  y:30,
  stagger:.4
});
tl.pause();

$(window).on('load', function(){
  tl.play();
})

var controller = new ScrollMagic.Controller();

var scene = new ScrollMagic.Scene({
	triggerElement: "main",
	triggerHook: 0,
	duration: "100%",
})
.setTween(".inner-banner", 1, {y: "-50%"})
.addTo(controller);

$('[data-fancybox]').fancybox({
	smallBtn: false,
	buttons: ["close"],
	image : {
        css : {
            width : '600px'
        }
    }

});
